import { Marker } from "@react-google-maps/api";
import React from "react";

import mapPin from "../../../images/svgs/icons/icon_map_pin.svg";
import mapPinSelected from "../../../images/svgs/icons/icon_map_pin_selected.svg";

export interface MapMarkerProps {
	isSelected: boolean;
	onClick: () => void;
	latitude: number;
	longitude: number;
	iconUrl?: Queries.CmsMapCardFragment;
	selectedIconUrl?: Queries.CmsMapCardFragment;
	title?: string;
}

const MapMarker: React.FC<MapMarkerProps> = ({
	isSelected,
	onClick,
	latitude,
	longitude,
	iconUrl: pinIconUrl,
	selectedIconUrl: pinIconSelectedUrl,
	title,
}) => {
	let pin = mapPin;
	let selectedPin = mapPinSelected;
	if (pinIconUrl.relationships.field_content_type.pinIconUrl?.length > 0) {
		pin = pinIconUrl.relationships.field_content_type.pinIconUrl;
	}
	if (
		pinIconSelectedUrl.relationships.field_content_type.pinIconSelectedUrl
			?.length > 0
	) {
		selectedPin =
			pinIconSelectedUrl.relationships.field_content_type.pinIconSelectedUrl;
	}

	return (
		<Marker
			onClick={onClick}
			icon={{
				url: isSelected ? selectedPin : pin,
			}}
			position={
				new window.google.maps.LatLng({
					lat: latitude,
					lng: longitude,
				})
			}
			title={title}
		/>
	);
};

export default MapMarker;
